import { useOrgListData } from 'auth'
import PageShell from 'components/PageShell'
import { Navigate, Route, Routes } from 'react-router-dom'
import AffiliateDetail from './AffiliateDetail'
import AffiliatesList from './AffiliatesList'

/** Cross-org Buyerflo-staff dashboard. Gated on the platformAdmin flag from getMe. */
export default function AdminApp() {
    const { orgListUserData } = useOrgListData()
    if (!orgListUserData.platformAdmin) {
        return (
            <Navigate
                to="/"
                replace
            />
        )
    }

    return (
        <PageShell title="Affiliate Admin">
            <Routes>
                <Route
                    path="/affiliates"
                    element={<AffiliatesList />}
                />
                <Route
                    path="/affiliates/:affiliateId"
                    element={<AffiliateDetail />}
                />
                <Route
                    path="*"
                    element={
                        <Navigate
                            to="affiliates"
                            replace
                        />
                    }
                />
            </Routes>
        </PageShell>
    )
}
